var ApprovalDealer = (function() {
	var __private = {
		forms: [],
		formClassName: "js__dealerApproval",
		disabledClassName: "disabled",
		popupClassName: "popup",
		popupShowClassName: "show",

		dataset: {
			url   : "approval",
			status: "status",
			itemID: "id",
			object: "object",
			type  : "type",
		},
		object: {
			license: "license",
			dealer : "dealer"
		},
		license: {
			can_approve: "can_approve_license",
			can_reject : "can_reject_license",
			reason     : "license_rejection_reason",
			has_rejected_license: "has_rejected_license"
		},
		dealer: {
			can_approve : "can_approve",
			can_reject  : "can_reject",
			reason      : "rejection_reason",
			is_approved : "is_approved",
			is_suspended: "is_suspended"
		},
		type: {
			approve: "approve",
			reject : "reject",
			reset  : "reset"
		},
		IDprefixes: {
			attention    : "attention-",
			licenseReason: "licenseReason-",
			dealersReason: "dealersReason-",
			noLicense    : "noLicense-",
			isLicense    : "isLicense-"
		},
		textarea: {
			license: "license_reason",
			dealer : "reason"
		},

		set() {
			for (let i = 0; i < document.getElementsByClassName(this.formClassName).length; i++) {
				const f = document.getElementsByClassName(this.formClassName)[i];
				
				if(f instanceof HTMLFormElement) this.forms.push(f);
			}

			// get statuses
			this.forms.forEach(f => {
				this.status(f);
			});
		},

		buttonsListener() {
			document.addEventListener("click", function(event) {
				event = event || window.event;
				var target = event.target;

				if(target instanceof HTMLElement && target.dataset[__private.dataset.type] !== undefined) {
					let type = target.dataset[__private.dataset.type];

					switch (type) {
						case __private.type.approve:
							__private.CLICK.action(target);
							break;
					
						case __private.type.reject:
							__private.CLICK.action(target);
							__private.CLICK.closePopup(target);
							break;

						case __private.type.reset:
							__private.CLICK.reset(target);
							break;
					}
				}
			});
		},

		textareaListener() {
			document.addEventListener("input", function(event) {
				event = event || window.event;
				var target = event.target;

				if(target instanceof HTMLTextAreaElement && (target.name === __private.textarea.license || target.name === __private.textarea.dealer)) {
					let form   = target.form;
					let button = form.querySelector(`*[data-${__private.dataset.type}='${__private.type.reject}']`);

					if(button instanceof HTMLInputElement || button instanceof HTMLButtonElement) {
						if(target.value && target.value !== "") {
							button.disabled = false;
							button.classList.remove(__private.disabledClassName);
						}
						else {
							button.disabled = true;
							button.classList.add(__private.disabledClassName);
						}
					}
				}
			});
		},

		status(form) {
			if(form instanceof HTMLFormElement) {
				let ID     = form.dataset[this.dataset.itemID];
				let item   = form.dataset[this.dataset.status];
				let object = form.dataset[this.dataset.object];
				let statusURL = `/ajax/${item}/${ID}/status`;

				Ajax.get(statusURL)
					.then(data => {
						var DATA = JSON.parse(data.responseText);

						console.log('------------------------------------');
						console.log(DATA);
						console.log('------------------------------------');

						switch (object) {
							case this.object.license:
								this.switchButtons(form, DATA[this.license.can_approve], DATA[this.license.can_reject]);
								this.setReason(`${this.IDprefixes.licenseReason}${ID}`, DATA[this.license.reason]);
								this.licenseAttention(ID, DATA[this.license.can_approve]);
								break;

							case this.object.dealer:
								this.switchButtons(form, DATA[this.dealer.can_approve], DATA[this.dealer.can_reject]);
								this.setReason(`${this.IDprefixes.dealersReason}${ID}`, DATA[this.dealer.reason]);
								break;
						}
					});
			}
		},

		switchButtons(form, resolve, reject) {
			var resButton = form.querySelector(`.${this.type.approve}`);
			var rejButton = form.querySelector(`.${this.type.reject}`);

			switcher(resButton, !resolve);
			switcher(rejButton, !reject);

			function switcher(button, flag) {
				if(button instanceof HTMLInputElement || button instanceof HTMLButtonElement)
					button.disabled = flag;
			}
		},

		setReason(ID, reason) {
			var reasonElem = document.getElementById(ID);

			if(reasonElem instanceof HTMLElement) {
				if(reason && reason !== null) reasonElem.textContent = reason;
				else reasonElem.textContent = "";
			}
		},

		licenseAttention(itemID, flag = false) {
			var attention = document.getElementById(`${this.IDprefixes.attention}${itemID}`);
			var noLicense = document.getElementById(`${this.IDprefixes.noLicense}${itemID}`);
			var isLicense = document.getElementById(`${this.IDprefixes.isLicense}${itemID}`);
			
			if(flag) {
				if(attention) attention.style.display = "block";
				if(noLicense) noLicense.style.display = "block";
				if(isLicense) isLicense.style.display = "none";
			} else {
				if(attention) attention.style.display = "none";
				if(noLicense) noLicense.style.display = "none";
				if(isLicense) isLicense.style.display = "block";
			}
		},

		CLICK: {
			action(btn) {
				var url = false;

				if(btn instanceof HTMLInputElement || btn instanceof HTMLButtonElement) {
					if(btn.dataset[__private.dataset.url] !== undefined) url = btn.dataset[__private.dataset.url];

					new Promise((resolve, reject) => {
						if(url) resolve(url);
					})
						.then(url => {
							//__private.disabledAll(btn.form, true);

							console.log('------------------------------------');
							console.log(url);
							console.log(btn.form.elements);
							console.log('------------------------------------');

							return Ajax.post(url, new FormData(btn.form));
						})
						.then(data => {
							//__private.disabledAll(btn.form, false);

							console.log('------------------------------------');
							console.log(data);
							console.log('------------------------------------');
							
							__private.status(btn.form);
						});
				}
			},

			closePopup(btn) {
				var popup = searchElementByClassName(btn, __private.popupClassName);
				if(popup instanceof HTMLElement) popup.classList.remove(__private.popupShowClassName);
			},

			reset(btn) {
				var form = btn.form;
				var textarea;

				if(form instanceof HTMLFormElement) {
					textarea = form.getElementsByTagName("textarea")[0];

					if(textarea) textarea.value = null;
				}
			}
		},

		disabledAll(form, flag) {
			var inputs = form.querySelectorAll("input.btn");
			var buttons= form.querySelectorAll("button.btn");

			setStatus(inputs,  flag);
			setStatus(buttons, flag);

			function setStatus(arr, flag) {
				for (let i = 0; i < arr.length; i++) {
					const element = arr[i];

					if(flag) {
						element.disabled = true;
						element.classList.add(__private.disabledClassName);
					}
				}

				if(!flag) __private.status(form);
			}
		}
	};

	return {
		init() {
			__private.set();
			__private.buttonsListener();
			__private.textareaListener();
		}
	};
})();


/**
 * Run module
 */
(function() {
	document.addEventListener("DOMContentLoaded", function() {
		var forms = document.getElementsByClassName("js__dealerApproval");

		if(forms.length > 0) ApprovalDealer.init();
	});
})();